import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b712d37e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column justify-start text-center left-drawer" }
const _hoisted_2 = { class: "wrapper-org" }
const _hoisted_3 = {
  key: 0,
  class: "slotItem navPanel"
}
const _hoisted_4 = {
  key: 1,
  class: "slotItem expandedPanel"
}

import { useAbility } from '@casl/vue';
import { computed, toRefs } from 'vue';
import { useRoute } from 'vue-router';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import usePanel from '@/hooks/usePanel';
import Tooltip from '@/common/Tooltip/Tooltip.vue';
import UserProfileDialog from '@/dialogs/UserProfileDialog/UserProfileDialog.vue';
import routeNames from '@/router/routeNames';
import { useUserStore } from '@/stores';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'LeftDrawerNavigation',
  props: {
    leftDrawerOpen: { type: Boolean }
  },
  setup(__props: any) {

const { can } = useAbility();



const { t } = useI18n();
const userStore = useUserStore();
const { isNavPanel, isExpandedPanel } = usePanel();
const q = useQuasar();
const route = useRoute();
const { user } = toRefs(userStore);

const isActiveBtn = (path: string) => new RegExp(path).test(route.path);

const listItemNavigation = computed(() => {
  const $route = useRoute();

  const list = [];
  if (can('read', 'Districts')) {
    list.push({
      to: { name: routeNames.districts },
      icon: 'mdi-earth',
      title: t('areas.title'),
      path: '/districts',
    });
  }
  if (can('read', 'Organizations')) {
    list.push({
      to: !can('read', 'Districts') ? '/' : {
        name: routeNames.organizations,
        query: $route.query.districtId ? { districtId: $route.query.districtId } : {},
      },
      icon: 'mdi-home-variant',
      title: t('organizations.title'),
      path: '/organizations',
    });
  }

  if (can('show', 'fieldMeteoIcons') || $route.query.organizationId) {
    list.push({
      to: { name: routeNames.fields, query: { ...$route.query } },
      icon: 'mdi-sprout',
      title: t('fields.title'),
      path: '/fields',
    });
  }

  if (can('show', 'fieldMeteoIcons')) {
    list.push({
      to: { name: routeNames.meteos },
      icon: 'mdi-weather-cloudy',
      title: t('meteoStations.title'),
      path: '/meteos',
    });
  }

  if (can('show', 'StationOperability')) {
    list.push({
      to: { name: routeNames.meteoHealth },
      icon: 'mdi-chart-bar-stacked',
      title: t('meteoStations.stationCapacityAssessment'),
      path: '/meteo-health',
    });
  }

  list.push({
    to: { name: routeNames.agrochemicalAnalysis },
    icon: 'mdi-flask-plus-outline',
    title: t('agroChemicalExamination.title'),
    path: '/agrochemical-analysis',
  });

  return list;
});

const openUserProfileDialog = () => {
  q.dialog({
    component: UserProfileDialog,
    componentProps: { user: user.value },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_drawer = _resolveComponent("q-drawer")!

  return (_openBlock(), _createBlock(_component_q_drawer, {
    "model-value": _ctx.leftDrawerOpen,
    width: _unref(isNavPanel) ? (_unref(isExpandedPanel) ? 837 : 461) : 56,
    side: "left",
    behavior: "desktop",
    bordered: "",
    class: "flex no-wrap"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_btn, {
          color: "no-border-radius",
          "text-color": "primary",
          icon: "mdi-account-circle-outline",
          onClick: openUserProfileDialog
        }, {
          default: _withCtx(() => [
            _createVNode(Tooltip, {
              title: _ctx.$t('personalAccount.title')
            }, null, 8, ["title"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItemNavigation.value, ({icon, to, title, path}) => {
          return (_openBlock(), _createBlock(_component_q_btn, {
            key: title,
            "text-color": "primary",
            icon: icon,
            class: _normalizeClass(isActiveBtn(path) ? 'router-link-active' : ''),
            onClick: openUserProfileDialog
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: to,
                class: "absolute full-width full-height",
                "active-class": "''"
              }, null, 8, ["to"]),
              _createVNode(Tooltip, { title: title }, null, 8, ["title"])
            ]),
            _: 2
          }, 1032, ["icon", "class"]))
        }), 128)),
        _createElementVNode("div", _hoisted_2, [
          (_unref(can)('show', 'directories'))
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                color: "primary no-border-radius",
                to: { name: _unref(routeNames).directories},
                icon: "mdi-notebook"
              }, {
                default: _withCtx(() => [
                  _createVNode(Tooltip, {
                    title: _ctx.$t('directories.title')
                  }, null, 8, ["title"])
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_btn, {
            color: "primary no-border-radius",
            to: { name: _unref(routeNames).organizationProfile},
            icon: "mdi-briefcase-variant"
          }, {
            default: _withCtx(() => [
              _createVNode(Tooltip, {
                title: _ctx.$t('organizations.settingOrganization')
              }, null, 8, ["title"])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      (_unref(isNavPanel))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_view, { name: "navPanel" })
          ]))
        : _createCommentVNode("", true),
      (_unref(isExpandedPanel))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_router_view, { name: "expandedPanel" })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "width"]))
}
}

})